import { Directive, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';

@Directive()
export class Unsubscriber implements OnDestroy {
	destroySubscriptions$: Subject<boolean> = new Subject<boolean>();

	ngOnDestroy(): void {
		this.destroySubscriptions$.next(true);
		this.destroySubscriptions$.unsubscribe();
	}
}
